/*** DEPENDENCIES ***/
import { Link as GatsbyLink } from "gatsby"
import React from "react"
import slashes from "remove-trailing-slash"
import { useThemeOptions } from "../hooks/useThemeOptions"
import { createLocalLink } from "../utils/createLocalLink"

/*** COMPONENTS ***/
import { Link as ChakraLink } from "@chakra-ui/react"

export interface LinkProps {
  to: string
  children: React.ReactNode
}

export const Link = ({ to = "", children }: LinkProps) => {
  if (!to) return children

  const { wordPressUrl } = useThemeOptions()
  const targetRelAttrs = { target: "_blank", rel: "noopener noreferrer" }
  const isExternalLink =
    !to.includes(wordPressUrl) &&
    !to.startsWith("/") &&
    (to.startsWith("https://") ||
      to.startsWith("http://") ||
      to.startsWith("tel:") ||
      to.startsWith("mailto:"))

  let url: string

  if (to === wordPressUrl) {
    url = "/"
  } else if (isExternalLink) {
    url = to
  } else {
    url = createLocalLink(to, slashes(wordPressUrl))
  }

  return isExternalLink ? (
    <ChakraLink href={url} {...targetRelAttrs}>
      {children}
    </ChakraLink>
  ) : (
    <GatsbyLink to={url}>{children}</GatsbyLink>
  )
}
